/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";

export const RulesIndentedBlock = styled("div")({
    paddingLeft: "1em",
    marginBottom: "1em",
});
